import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Modal, Tabs } from "antd"
import { withRouter } from "react-router-dom";
import LoginByPhone from "./LoginByPhone";
import LoginByCard from "./LoginByCard";
const TabPane = Tabs.TabPane;

export class LoginModal extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {

  }
  render() {
    const { visible, onCancel } = this.props;
    return (
      <div className="common-login-modal">
        <Modal
          className="loginModal"
          width={360}
          visible={visible}
          centered
          onCancel={onCancel}
          footer={null}
        >
          <Tabs defaultActiveKey="1" className="login-tabs">
            <TabPane tab="手机快捷登录" key="1">
              <LoginByPhone {...this.props} isNotJump={true} />
            </TabPane>
            <TabPane tab="密码登录" key="2">
              <LoginByCard {...this.props} isNotJump={true} />
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(LoginModal));



// WEBPACK FOOTER //
// ./src/features/common/LoginModal.js